import { fromJS } from 'immutable';
import { createStore } from 'reflux';
import WeatherActions from './weather_actions';
import SettingsStore from './settings_store';
import request from 'superagent';
import moment from 'moment';
// API key for Open Weather Map
const API_KEY = '8cf70186b83fbddb3ba8c8520c25a88e';


const WeatherStore = createStore({

  listenables: [ WeatherActions ],

  init() {
    this.weather = fromJS({
      image: 'noweather',
      date: moment().format('dddd DD/MM'),
      city: '-//-',
      conditions: '',
      temp: '-//-',
      temp_max: '-//-',
      temp_min: '-//-',
      wind: '-//-',
      humidity: '-//-',
      pressure: '-//-',
      cloudiness: '-//-'
    });
  },

  getInitialState() {
    return {
      message: '',
      weather: this.weather
    };
  },

  onGetLocation() {
    request
      .get('https://www.pollfish.com/geolocation')
      .end((err, res) => {
        if (!err) {
          const city = this.getCityName(res.body);
          this.weather = this.weather.set('city', `${city}`);
          this.getWeatherInfo();
        } else {
          // NOTE: fallback to default values instead of showing errors. This happened for demonstration purposes.
          //       so that it doesn't break while trying to demo the webplugin to a publisher
          this.weather = this.weather.set('city', `New York`);
          this.getWeatherInfo();
          // this.trigger({ message: 'Unable to retrieve your location.\n Please make sure you have disabled any ad blockers.' });
        }
      });
  },

  getWeatherInfo() {
    const settings = SettingsStore.getInitialState();
    const units = settings.get('units') === 'c'
      ? 'metric'
      : 'imperial';

    request
      .get('https://www.pollfish.com/webplugin/weather')
      .query({
        q: this.weather.get('city'),
        appid: API_KEY,
        units
      })
      .end((err, res) => {
        if (!err) {
          const {
            humidity,
            pressure,
            temp,
            temp_max,
            temp_min
          } = res.body.main;
          const conditions = res.body.weather[0].main;
          const cloudiness = res.body.clouds.all;
          const wind = res.body.wind.speed;
          const image = this.getImageName(res.body.weather[0].id, temp, units);

          // convert to metric or imperial system
          this.weather = this.weather.merge(fromJS({
            humidity,
            pressure,
            cloudiness,
            conditions,
            image,
            temp: Math.round(temp),
            temp_max: Math.round(temp_max),
            temp_min: Math.round(temp_min),
            wind
          }));
          this.trigger({ weather: this.weather });
        } else {
          // NOTE: fallback to default values instead of showing errors. This happened for demonstration purposes.
          //       so that it doesn't break while trying to demo the webplugin to a publisher
          this.weather = this.weather.merge(fromJS(this.getDefaultWeatherValues()));
          this.trigger({ weather: this.weather });
          // this.trigger({ message: 'Unable to retrieve weather data.\n Please make sure you have disabled any ad blockers.' });
        }
      });
  },

  getImageName(code, avgTemp, units) {
    const isHot = units === 'metric' ? '35' : '95';

    if ((code >= 200 && code <= 232)) {
      return 'heavy_rain';
    }
    if ((code >= 300 && code <= 321) || (code >= 500 && code <= 531)) {
      return 'shower';
    }

    if ((code >= 600 && code <= 622)) {
      return 'snow';
    }

    if (code === 800 && isHot) {
      return 'hot';
    }

    return 'partly_cloudy';
  },

  // NOTE: There is a whole json gzip for country code id's but we just 
  //       map for the Athens, GR country currently.
  getCityName(location = {}) {
    const country = location.country_code && location.country_name;
    const city = location.city_name;
    if (country === 'GR' && city === 'Athens') {
      return 'Athens, GR';
    }
    return city;
  },

  getDefaultWeatherValues() { 
    return {
      'humidity': 69,
      'pressure': 1019,
      'cloudiness': 75,
      'conditions': 'Haze',
      'image': 'partly_cloudy',
      'temp': 26,
      'temp_max': 28,
      'temp_min': 25,
      'wind': 3.1,
    }
  },

});

export default WeatherStore;




// WEBPACK FOOTER //
// ./src/components/weather/weather_store.js